/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Provider_TitleInputs */

const en_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Provider`)
};

const de_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Anbieter`)
};

const fr_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur d'IA`)
};

const es_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor de IA`)
};

const it_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitore AI`)
};

const nl_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-provider`)
};

const pl_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostawca AI`)
};

const fi_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-palveluntarjoaja`)
};

const da_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-leverandør`)
};

const sv_settings_ai_provider_title = /** @type {(inputs: Settings_Ai_Provider_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-leverantör`)
};

/**
* | output |
* | --- |
* | "AI Provider" |
*
* @param {Settings_Ai_Provider_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_provider_title = /** @type {((inputs?: Settings_Ai_Provider_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Provider_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_provider_title(inputs)
	if (locale === "fr") return fr_settings_ai_provider_title(inputs)
	if (locale === "es") return es_settings_ai_provider_title(inputs)
	if (locale === "it") return it_settings_ai_provider_title(inputs)
	if (locale === "nl") return nl_settings_ai_provider_title(inputs)
	if (locale === "pl") return pl_settings_ai_provider_title(inputs)
	if (locale === "fi") return fi_settings_ai_provider_title(inputs)
	if (locale === "da") return da_settings_ai_provider_title(inputs)
	if (locale === "sv") return sv_settings_ai_provider_title(inputs)
	return en_settings_ai_provider_title(inputs)
});